import RequestStatus from "../model/RequestStatus";
import { UserPreference, UserPreferenceResponse } from "../model/UserPreference";

export const USER_PREFERENCE_QUERY_START = 'USER_PREFERENCE_QUERY_START';
export const USER_PREFERENCE_QUERY_SUCCESS = 'USER_PREFERENCE_QUERY_SUCCESS';
export const USER_PREFERENCE_QUERY_FAILED = 'USER_PREFERENCE_QUERY_FAILED';

export const USER_PREFERENCE_UPDATE_START = 'USER_PREFERENCE_UPDATE_START';
export const USER_PREFERENCE_UPDATE_SUCCESS = 'USER_PREFERENCE_UPDATE_SUCCESS';
export const USER_PREFERENCE_UPDATE_FAILED = 'USER_PREFERENCE_UPDATE_FAILED';

export interface UserPreferenceQueryStartAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
}

export const setUserPreferenceQueryStart = (): UserPreferenceQueryStartAction => ({
    type: USER_PREFERENCE_QUERY_START,
    requestStatus: RequestStatus.LOADING,
});

export interface GetUserPreferenceQueryComplete {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly currentCountryCode: string;
    readonly userPreference: any;
}

export const getUserPreferenceQuerySuccessAction = (response: UserPreferenceResponse): GetUserPreferenceQueryComplete => ({
    type: USER_PREFERENCE_QUERY_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    currentCountryCode: response.currentCountryCode,
    userPreference: response.userPreference
});

export const getUserPreferenceQueryFailedAction = (): GetUserPreferenceQueryComplete => ({
    type: USER_PREFERENCE_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    currentCountryCode: '',
    userPreference: null
});

export interface UserPreferenceUpdateStartAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly userPreference: UserPreference;
}

export interface GetUserPreferenceUpdateComplete {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly userPreference: any;
}

export const setUserPreferenceUpdateStart = (userPreference: UserPreference) : UserPreferenceUpdateStartAction => ({
    type: USER_PREFERENCE_UPDATE_START,
    requestStatus: RequestStatus.LOADING,
    userPreference: userPreference
});

export const getUserPreferenceUpdateSuccessAction = (userPreference: UserPreference): GetUserPreferenceUpdateComplete => ({
    type: USER_PREFERENCE_UPDATE_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    userPreference: userPreference
});

export const getUserPreferenceUpdateFailedAction = (): GetUserPreferenceUpdateComplete => ({
    type: USER_PREFERENCE_UPDATE_FAILED,
    requestStatus: RequestStatus.ERROR,
    userPreference: null
});
